import { createFileRoute, redirect } from '@tanstack/react-router';
import { GUARD_PATHS, ensureAccess, requireFeature, requireSession } from '@portal/platform/guards';
import { EditorLinkPage } from '@/features/customer-portal-editor/editor-link-page';
import { EDITOR_FLOWS, FEATURE_KEY } from '@/features/customer-portal-editor/texts';

/**
 * The way to the customer-portal layout editor, which runs on the tenant's own site. The menu
 * entry rides on the email builder's feature. Either product line's template permission admits
 * it, as it does the editor's API (each flow then checks its own) — `requireFeature` only knows
 * "all of", so the "any of" is checked here.
 */
export const Route = createFileRoute('/_app/customer-portal-editor')({
  staticData: { featureKey: FEATURE_KEY },
  beforeLoad: async ({ context, location }) => {
    await requireFeature(context, location, { feature: FEATURE_KEY });
    const { session } = context;
    if (session.isGlobalAdmin && session.scope.viewMode !== 'scoped') {
      return;
    }
    const access = await ensureAccess(context, requireSession(context, location));
    if (!EDITOR_FLOWS.some(({ permission }) => access.permissions.includes(permission))) {
      throw redirect({ href: GUARD_PATHS.unauthorized });
    }
  },
  component: EditorLinkPage,
});
